import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import ShowField from "v4/components/form/ShowField/ShowField";
import PolPopup from "v4/components/ui/PolPopup/PolPopup";
import QuoteLineDescriptionEditor
    from "v4/features/front/products/components/QuotesProductsDetails/components/QuotesProductsTable/components/QuoteLineDescription/components/QuoteLineDescriptionEditor/QuoteLineDescriptionEditor";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useToggle from "v4/hooks/useToggle";
import ReactTooltip from "react-tooltip";
import './QuoteLineDescription.scss';

export default function QuoteLineDescription({isShow, name, field, formMetadata}) {
    const {t} = usePolTranslation();
    const [showPopup, togglePopup] = useToggle();

    if (!field.description && isShow) return null;

    return (
        <>
            <button type="button"
                    className="quote-line-description-btn-icon btn btn-primary btn-full"
                    onClick={togglePopup}
                    data-tip={t(isShow ? 'product_description' : 'edit_description')}
                    data-for={`desc-tooltip-${field.id || name}`}>
                <PolIcon icon={isShow ? 'eye' : 'paragraph'}/>
            </button>
            <ReactTooltip id={`desc-tooltip-${field.id || name}`} effect="solid"/>
            <PolPopup isOpen={showPopup}
                      closePopup={togglePopup}
                      sticked={{header: true}}
                      title={t(isShow ? 'product_description' : 'edit_description')}>
                {isShow
                    ? <ShowField type="text-rich-editor"
                                 value={field.description ?? ''}
                                 formMetadata={formMetadata}/>
                    : <QuoteLineDescriptionEditor name={name} togglePopup={togglePopup}/>
                }
            </PolPopup>
        </>
    )
}
